<bt-loader [loaderId]="loaderId">
  @if(photographer || photographers.data){

  }
  <div class="flex vertical full-height">
    <div class="flex-1 overflow margin-bottom margin-top">
      <div class="flex center">
        <div class="flex-1 margin-right">
          <div class="margin-bottom-small">
            Photographer
          </div>
          @if(!!photographer){
          <input type="text" class="full-width" readonly [value]="photographer.fullName">
          }
          @if(!photographer){
          <bt-autocomplete [datasource]="photographers.data" [settings]="photographers.settings"
            [page]="photographers.page" (nextPage)="getPhotographers(photographers.page + 1)"
            (filterChange)="onPhotographersFilterChange($event)"
            (selected)="onSelectPhotographer($event)"></bt-autocomplete>
          }
        </div>
        <div class="flex-1">
          <div class="margin-bottom-small">Due Date</div>
          <input type="date" class="full-width" [min]="todayDate" [(ngModel)]="dueDate">
        </div>
      </div>
      <div class="margin-bottom-small margin-top">Warehouse</div>
      <div class="margin-bottom-small">
        <bt-autocomplete [datasource]="warehouses.data" [currentSelected]="warehouses.selected"
          [settings]="warehouses.autocompleteSettings" [loaderId]="warehouses.loaderId"
          [disabledProperty]="!photographer && !photographers.selected" [page]="warehouses.page"
          (open)="onOpenWarehousesAutocomplete()" (nextPage)="getWarehouses()"
          (filterChange)="onWarehousesFilterChange($event)" (selected)="onSelectWarehouse($event)"></bt-autocomplete>
      </div>
      <div class="margin-bottom-small margin-top">Styles</div>
      <div class="flex center margin-bottom-small">
        <div class="flex-1 margin-right">
          <div class="margin-bottom-small">
            <bt-autocomplete [datasource]="styles.data" [currentSelected]="styles.selected"
              [settings]="styles.autocompleteSettings" [loaderId]="styles.loaderId"
              [disabledProperty]="!warehouses.selected" [page]="styles.page"
              (filterChange)="onStylesFilterChange($event)" (nextPage)="getStyles(styles.page + 1)"
              (open)="onOpenStylesAutocomplete()" (selected)="onSelectStyle($event)"></bt-autocomplete>
          </div>
          <bt-multiselect [datasource]="colors.data" [nextDatasource]="colors.nextData"
            [settings]="colors.multiselectSettings" [disabled]="!warehouses.selected || !styles.selected"
            [currentSelections]="colors.selections" [page]="colors.page" [loaderId]="colors.loaderId"
            (selections)="onSelectColors($event)" (nextPage)="getColors()"
            (filterChange)="onColorsFilterChange($event)" (open)="onOpenColorsMultiselect()"></bt-multiselect>
        </div>
        <div class="flex-0">
          <button [disabled]="!colors.selections || !colors.selections.length" (click)="onAddStyle()">
            <i class="fa fa-plus"></i>Add
          </button>
        </div>
      </div>
      <div>
        @for(c of chips; track c){
        <span class="chip margin-left-x-small margin-right-x-small margin-top-x-small" [title]="c.title">
          Style: {{c.style.styleCode}} - {{c.colors.length}} colors
          <i class="fa fa-times margin-left-small" (click)="removeStyle(c)"></i>
        </span>
        }
      </div>
      <div class="margin-bottom-small margin-top">Comments</div>
      <textarea rows="6" class="full-width" cols="50" [(ngModel)]="comments"></textarea>
    </div>
    <div class="flex-0">
      <button class="full-width" (click)="createOrder()">
        <i class="fa fa-check"></i>Create order
      </button>
    </div>
  </div>
</bt-loader>